export default function About() {
  return (
    <div data-testid="about-page" className="max-w-6xl mx-auto px-6 lg:px-10 py-16">
      <div className="sk-badge sk-badge-gold">About us</div>
      <h1 className="mt-4 font-display text-5xl text-white leading-tight">Ten years of <span className="gold italic">trusted lending</span></h1>
      <p className="mt-6 text-white/70 max-w-2xl text-lg leading-relaxed">
        SK Group Financial Services was founded in 2015 with a simple mission — democratize access to fair,
        transparent financial products for every Indian. Today, we work with 40+ government banks and NBFC
        partners to bring you the industry's best interest rates on Home, Business, Personal, Gold and
        Property loans, plus curated insurance solutions.
      </p>
      <div className="mt-14 grid md:grid-cols-3 gap-6">
        {[
          { h: "₹500 Cr+", s: "Total loans disbursed" },
          { h: "25,000+", s: "Families & businesses funded" },
          { h: "40+", s: "Bank & NBFC partners" },
        ].map((x, i) => (
          <div key={i} className="sk-card-dark p-8">
            <div className="font-display text-4xl gold">{x.h}</div>
            <div className="text-white/60 mt-2">{x.s}</div>
          </div>
        ))}
      </div>
      <div className="mt-16 grid lg:grid-cols-2 gap-10">
        <div>
          <h2 className="font-display text-3xl text-white">Our mission</h2>
          <p className="mt-4 text-white/60 leading-relaxed">
            To be India's most customer-obsessed loan advisory — combining human warmth with technology to
            deliver a lending experience that is fast, fair, and transparent.
          </p>
        </div>
        <div>
          <h2 className="font-display text-3xl text-white">Our promise</h2>
          <ul className="mt-4 space-y-3 text-white/60">
            <li>✓ Zero hidden charges — every fee disclosed upfront.</li>
            <li>✓ Response within 60 minutes on every application.</li>
            <li>✓ Dedicated relationship manager from application to disbursal.</li>
            <li>✓ Data privacy — your KYC is stored in bank-grade encrypted vaults.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
